/* eslint-disable */
import isotope from "isotope-layout";

export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		$(document).ready(function() {

			let $search = $("#search-results").isotope({
        itemSelector: ".search-result",
        percentPosition: true,
        filter: "*",
        masonry: {
          columnWidth: ".search-result",
        },
        visibleStyle: {
          opacity: 1
        },
        hiddenStyle: {
          opacity: 0
        }
      });


      $(".search-filter__list li > button.search-filter__button").on("click", function(e) {
        const resultCount = $('.search-results-count .results');

        $('.search-filter__list').removeClass('is-open');
        $('.search-filter__button__icon').removeClass('is-positive');

        updateButtonText(this);

        let filterValue = $(this).attr("data-filter");

        $search.isotope({
          filter: filterValue
        });

        const count = $search.data('isotope').filteredItems.length;
        $(resultCount).text(count);

      });

      $search.on('arrangeComplete', function(event, filteredItems) {
        let noResultsContainer = $('.search-no-results');
        let resultCount = filteredItems.length;

        if (resultCount == 0) {
          noResultsContainer.removeClass('hidden');
        } else {
          noResultsContainer.addClass('hidden');
        }
      });

      $(".search-filter__wrapper").each(function(i, buttonGroup) {
        let $buttonGroup = $(buttonGroup);
        $buttonGroup.on("click", ".search-filter__list .search-filter__button", function() {
          $buttonGroup.find(".is-checked").removeClass("is-checked");
          $(this).addClass("is-checked");
        });
      });

      $(".search-filter__button--all").on("click", function() {
        $(this).next("ul").toggleClass("is-open");
        $(this).find(".pmi").toggleClass("is-positive");
      });

      let iso = $search.data('isotope'); // get Isotope instance
      $search.isotope('reveal', iso.items);
      $(window).load(() => {
        iso.layout();
      });

      // loadMore(10); //execute function onload

      //****************************
      // Isotope Load more button
      //****************************
      // let initShow = 10; //number of images loaded on init & onclick load more button
      // let counter = initShow; //counter for load more button
      // loadMore(initShow); //execute function onload

      // function loadMore(toShow) {
      //   $search.find(".hidden").removeClass("hidden");

      //   let hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
      //     return item.element;
      //   });
      //   $(hiddenElems).addClass('hidden');
      //   $search.isotope('layout');

      //   //when no more to load, hide show more button
      //   if (hiddenElems.length === 0) {
      //     $("#load-more").hide();
      //   } else {
      //     $("#load-more").show();
      //   };

      // }

      //append load more button
      // $search.after('');

      //when load more button clicked
      // $("#load-more").click(function() {
      //   if ($('#filters').data('clicked')) {
      //     //when filter button clicked, set initial value for counter
      //     counter = initShow;
      //     j$('#filters').data('clicked', false);
      //   } else {
      //     counter = counter;
      //   };

      //   counter = counter + initShow;

      //   loadMore(counter);
      // });

      function updateButtonText(elem) {
        let type = elem.getAttribute('data-type');
        let allBtn = document.querySelector('.search-filter__button__all');
        let parentBtn = document.querySelector('.search-filter__button--all span');

        if (elem.classList.contains('search-filter__button__all')) {
          allBtn.style.display = 'none';
        } else {
          allBtn.style.display = 'block';
        }

        parentBtn.innerHTML = elem.innerHTML;
      }

    });
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/search.js